import { NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularFireModule } from "@angular/fire";
import { environment } from "src/environments/environment";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { AngularFireFunctionsModule, ORIGIN } from "@angular/fire/functions";

import { HttpClientModule } from "@angular/common/http";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Ng5SliderModule } from "ng5-slider";

import {
  SummaryByProductComponent,
  SummaryByDowComponent,
  SummaryByActiveDaysComponent,
  OrdersTableComponent
} from "../venue/components/tables";
import { MatToolbarModule } from "@angular/material/toolbar";
import { PageHeaderComponent } from "../admin/components/layout/page-header/page-header.component";
import {
  IconsModule,
  MDBBootstrapModulesPro,
  MDBSpinningPreloader
} from "ng-uikit-pro-standard";
import { FilterOrdersComponent } from "../admin/components/forms/filter-orders/filter-orders.component";
import { ConfirmRedeemComponent } from "./components/popups/confirm-redeem/confirm-redeem.component";
import { ToastModule } from "ng-uikit-pro-standard";

import { MatChipsModule } from "@angular/material/chips";

import { WelcomeUserComponent } from "./components/cards/welcome-user/welcome-user.component";
import { PeriodTotalsCardComponent } from "../venue/components/cards/period-totals-card/period-totals-card.component";
import * as admin from "firebase-admin";
import { PushNotificationGalleryComponent } from "./components/popups/push-notification-gallery/push-notification-gallery.component";
import { PushNotificationRecievedComponent } from "./components/popups/push-notification-recieved/push-notification-recieved.component";
import { DateDetailsPopupComponent } from "./components/popups/date-details-popup/date-details-popup.component";
import { CalendarPickerComponent } from "./components/forms/calendar-picker/calendar-picker.component";
import { AddPassToDatePopupComponent } from "./components/popups/add-pass-to-date-popup/add-pass-to-date-popup.component";
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatFormFieldModule } from "@angular/material/form-field";
import { PassCardComponent } from "./components/cards/pass-card/pass-card.component";
import { PassListComponent } from "./components/layouts/pass-list/pass-list.component";
import { MatRadioModule } from "@angular/material/radio";
import { MatListModule } from "@angular/material/list";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSliderModule } from "@angular/material/slider";
import { PrimaryButtonComponent } from "./components/primary-button.component";
import { SecondaryButtonComponent } from "./components/secondary-button.component";
import { TertiaryButtonComponent } from "./components/tertiary-button.component";
import { LinkButtonComponent } from "./components/link-button.component";
import { IconButtonComponent } from "./components/icon-button.component";
import { CalendarFormComponent } from "./components/calendar-form/calendar-form.component";
import { FeathersModule } from "../icons/icons.module";
import { TimeDirective } from "./directives/time.directive";
import { DateDirective } from "./directives/date.directive";
import { PhoneDirective } from "./directives/phone.directive";
import { ClipboardModule } from "@angular/cdk/clipboard";

import { ConfirmPopupComponent } from "./components/dialogs/confirm-popup/confirm-popup.component";
@NgModule({
  declarations: [
    SummaryByProductComponent,
    SummaryByDowComponent,
    SummaryByActiveDaysComponent,
    OrdersTableComponent,
    PageHeaderComponent,
    FilterOrdersComponent,
    ConfirmRedeemComponent,
    WelcomeUserComponent,
    PeriodTotalsCardComponent,
    PushNotificationGalleryComponent,
    PushNotificationRecievedComponent,
    DateDetailsPopupComponent,
    CalendarPickerComponent,
    AddPassToDatePopupComponent,
    PassCardComponent,
    PassListComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    TertiaryButtonComponent,
    LinkButtonComponent,
    IconButtonComponent,
    CalendarFormComponent,
    TimeDirective,
    DateDirective,
    PhoneDirective,
    ConfirmPopupComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireAuthModule,
    FormsModule,
    ClipboardModule,
    ReactiveFormsModule,
    CommonModule,
    MatTableModule,
    HttpClientModule,
    DragDropModule,
    IconsModule,
    RouterModule,
    MatSelectModule,
    MatChipsModule,
    FontAwesomeModule,
    MatToolbarModule,
    MatExpansionModule,
    MatRadioModule,
    NgbModule,
    MatListModule,
    MatSliderModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTabsModule,
    MatCheckboxModule,
    Ng5SliderModule,
    FeathersModule,
    MatMenuModule,
    MDBBootstrapModulesPro.forRoot(),

    MatButtonModule,
    MatIconModule
    // ToastModule.forRoot(),
  ],
  providers: [
    MDBSpinningPreloader,
    MatDialogModule,
    { provide: ORIGIN, useValue: "http://localhost:4200" }
  ],
  exports: [
    AngularFirestoreModule,
    AngularFireStorageModule,
    Ng5SliderModule,
    MatChipsModule,
    MatToolbarModule,
    ClipboardModule,
    AngularFireAuthModule,
    MatExpansionModule,
    TertiaryButtonComponent,
    OrdersTableComponent,
    CalendarFormComponent,
    FormsModule,
    SummaryByProductComponent,
    MatDialogModule,
    MatListModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    CommonModule,
    MatMenuModule,
    HttpClientModule,
    AngularFireModule,
    MatSliderModule,
    DragDropModule,
    MatRadioModule,
    SecondaryButtonComponent,
    RouterModule,
    PrimaryButtonComponent,
    FontAwesomeModule,
    NgbModule,
    MatTabsModule,
    FilterOrdersComponent,
    PageHeaderComponent,
    SummaryByDowComponent,
    MDBBootstrapModulesPro,
    SummaryByActiveDaysComponent,
    PushNotificationGalleryComponent,
    WelcomeUserComponent,
    PeriodTotalsCardComponent,
    PushNotificationRecievedComponent,
    DateDetailsPopupComponent,
    CalendarPickerComponent,
    TimeDirective,
    DateDirective,
    PhoneDirective
  ],
  entryComponents: [
    ConfirmRedeemComponent,
    PushNotificationGalleryComponent,
    DateDetailsPopupComponent,
    AddPassToDatePopupComponent
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule {}
